// extracted by mini-css-extract-plugin
export default {"errorBoundaryComponentSmall":"_1deYN0sBU1_7XhSvzTWpiS"};